/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import React from "react";
import MetaTitle from "../../meta/title";
import MetaDescription from "../../meta/description";
import MetaCanonical from "../../meta/canonical";
import MetaUrl from "../../meta/url";
import Head from "next/head";
import { useRouter } from "next/router";
import MetaImage from "../../meta/image";

export default function CategoryMeta({category, canonicalPath}) {
	const router = useRouter();
	const { query } = router;
	const { page } = query;

	function getMetaTitle() {
		let title = category.translated.metaTitle || category.translated.name;

		if (title.indexOf('&amp;') > 0) {
			title = title.replace('&amp;', '&');
		}

		if (canonicalPath === '/' || title.indexOf(' - Newport') > 0 || title.indexOf(' -  Newport') > 0) {
			return title;
		}

		return title + ' - Newport';
	}

	function isOldENIEUrl(locale, salesChannel) {
		return locale === 'en-IE' && salesChannel === '5fe6fddfe24e4b358efcac6cda56ea7f';
	}

	function getHrefLangTags() {
		let hrefLangUrls = category?.translated?.customFields?.seoUrls;

		if(hrefLangUrls && hrefLangUrls.length > 0) {
			return hrefLangUrls.filter((seoUrl) => !isOldENIEUrl(seoUrl.locale, seoUrl.salesChannel)).map((seoUrl, index) => {
				let hreflang = seoUrl.locale === 'en-IE' ? 'en' : seoUrl.locale;

				return <link
					key={`cat-${index}-${seoUrl.url}`}
					rel="alternate"
					hreflang={hreflang}
					href={seoUrl.url}
				/>
			});
		}

		return '';
	}

	function getCanonical() {
		if (category.translated.customFields.url_custom_canonical_slug) {
			canonicalPath = category.translated.customFields.url_custom_canonical_slug
		}
		const canonicalWithPage = page && page > 1 ? canonicalPath + '?page=' + page : canonicalPath;
		return canonicalWithPage
	}

	return (
		<>
			<MetaTitle title={getMetaTitle()} />
			<MetaDescription description={category.translated.metaDescription || category.translated.description} />
			<MetaCanonical canonicalPathInfo={getCanonical()} />
			<MetaImage image={category.media ? category.media.url : ''}/>
			<MetaUrl url={canonicalPath} />

			<Head>
				{getHrefLangTags()}
			</Head>
		</>
	);
}
